<template>
  <td class="table-filesize-cell" :class="{ true: boolean, false: !boolean }">
    {{ size }}
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  computed: {
    size() {
      return this.$sdk.files.filesize(this.value);
    },
  },
};
</script>
<style scoped lang="scss">
td {
  text-align: center;
  opacity: 0.5;
  font-size: 0.9em;
}
</style>
